"use client"

import { phaseColorMap } from "@/lib/phases"
import { toKebabCase } from "@/lib/string"
import { cn } from "@/lib/utils"
import React from "react"
import Link from "next/link"

// Using the same structure as the Tag component but with phase-specific styling
interface PhaseTagProps {
  label: string
  color: "blue" | "yellow" | "green"
  className?: string
}

export function PhaseTag({ label, color, className = "" }: PhaseTagProps) {
  // Get color styles from the centralized color map
  const colorStyles = phaseColorMap[color]

  // Base styles for the tag
  const baseStyles = cn(
    "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition-colors",
    colorStyles.tagBg,
    colorStyles.tagText,
    colorStyles.tagHoverBg,
    className
  )

  // Convert label to kebab-case for URL
  const kebabLabel = toKebabCase(label)

  // Prevent parent click events from triggering
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <Link
      href={`/search/tag/${kebabLabel}`}
      className={baseStyles}
      onClick={handleClick}
    >
      <svg
        className="mr-1.5 h-2 w-2"
        fill="currentColor"
        viewBox="0 0 8 8"
      >
        <circle
          cx="4"
          cy="4"
          r="3"
        />
      </svg>
      {label}
    </Link>
  )
}
